// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Icon from "../../resources/images-and-icons/Icon.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as React from "react";
import * as Avatar from "../../resources/feedback-indicators/Avatar.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

function makeName(firstName, lastName, companyName) {
  let firstName$1 = Stdlib_Option.map(firstName, prim => prim.trim());
  let lastName$1 = Stdlib_Option.map(lastName, prim => prim.trim());
  let companyName$1 = Stdlib_Option.map(companyName, prim => prim.trim());
  if (companyName$1 !== undefined) {
    return companyName$1;
  } else if (firstName$1 !== undefined) {
    if (lastName$1 !== undefined) {
      return firstName$1 + " " + lastName$1.toUpperCase();
    } else {
      return;
    }
  } else if (lastName$1 !== undefined) {
    return lastName$1.toUpperCase();
  } else {
    return;
  }
}

let values = [
  "Individual",
  "LoyaltyMember",
  "Business"
];

function toLabel(value) {
  switch (value) {
    case "Individual" :
      return I18n.t("Individual");
    case "LoyaltyMember" :
      return I18n.t("Individual + loyalty");
    case "Business" :
      return I18n.t("Business");
  }
}

function toString(value) {
  switch (value) {
    case "Individual" :
      return "individual";
    case "LoyaltyMember" :
      return "loyalty-member";
    case "Business" :
      return "business";
  }
}

function fromString(value) {
  return values.find(current => toString(current) === value);
}

let Kind = {
  values: values,
  toLabel: toLabel,
  toString: toString,
  fromString: fromString
};

let values$1 = [
  "Active",
  "Archived"
];

function toLabel$1(value) {
  if (value === "Active") {
    return I18n.t("Active");
  } else {
    return I18n.t("Archived");
  }
}

function toString$1(value) {
  if (value === "Active") {
    return "active";
  } else {
    return "archived";
  }
}

function fromString$1(value) {
  return values$1.find(current => toString$1(current) === value);
}

function fromArchivedAt(archivedAt) {
  if (Stdlib_Option.isSome(archivedAt)) {
    return "Archived";
  } else {
    return "Active";
  }
}

function toStyleSet(value) {
  if (value === "Active") {
    return {
      bgColor: "#CEFDE0",
      textColor: "#00653E",
      borderColor: "#66EFAC",
      iconSvg: JsxRuntime.jsx(Icon.make, {
        name: "tick",
        fill: "#00653E",
        width: 11,
        height: 11,
        bold: true
      })
    };
  } else {
    return {
      bgColor: "#E7E7EE",
      textColor: "#25243A",
      borderColor: "#A2A1B0",
      iconSvg: JsxRuntime.jsx(Icon.make, {
        name: "archive",
        fill: "#25243A",
        width: 11,
        height: 11,
        bold: true
      })
    };
  }
}

let make = React.memo(props => {
  let __size = props.size;
  let archivedAt = props.archivedAt;
  let value = props.value;
  let size = __size !== undefined ? __size : "medium";
  let styleSet = toStyleSet(value);
  let badge = JsxRuntime.jsx(Badge.make, {
    children: toLabel$1(value),
    iconSvg: styleSet.iconSvg,
    size: size,
    borderColor: styleSet.borderColor,
    backgroundColor: styleSet.bgColor,
    foregroundColor: styleSet.textColor
  });
  if (value === "Active" || archivedAt === undefined) {
    return badge;
  } else {
    return JsxRuntime.jsx(Tooltip.make, {
      children: badge,
      placement: "top",
      content: JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.template(I18n.t("Archived on {{date}} at {{time}}"), {
          date: DateHelpers.formateToShortDate(archivedAt),
          time: DateHelpers.formateToShortTime(undefined, archivedAt)
        }, undefined)
      })
    });
  }
});

let Badge$1 = {
  toStyleSet: toStyleSet,
  make: make
};

let Status = {
  values: values$1,
  toLabel: toLabel$1,
  toString: toString$1,
  fromString: fromString$1,
  fromArchivedAt: fromArchivedAt,
  FeedbackBadge: undefined,
  Badge: Badge$1
};

function formatAge(dateOfBirth) {
  let now = new Date();
  let age = now.getFullYear() - dateOfBirth.getFullYear() | 0;
  let hasBirthdayPassed = now.getMonth() > dateOfBirth.getMonth() || now.getMonth() === dateOfBirth.getMonth() && now.getDate() >= dateOfBirth.getDate();
  let age$1 = hasBirthdayPassed ? age : age - 1 | 0;
  return age$1.toString() + " " + I18n.t("years");
}

function isBirthdaySoon(dateOfBirth) {
  let now = new Date();
  let nowMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  let bMonth = dateOfBirth.getMonth();
  let bDay = dateOfBirth.getDate();
  let thisYear = new Date(now.getFullYear(), bMonth, bDay);
  let nextYear = new Date(now.getFullYear() + 1 | 0, bMonth, bDay);
  let sevenDaysMs = 7 * 86400000;
  let nowTime = nowMidnight.getTime();
  let diffThis = thisYear.getTime() - nowTime;
  let diffNext = nextYear.getTime() - nowTime;
  if (diffThis >= 0 && diffThis <= sevenDaysMs) {
    return true;
  } else if (diffNext >= 0) {
    return diffNext <= sevenDaysMs;
  } else {
    return false;
  }
}

let make$1 = React.memo(props => {
  let __compact = props.compact;
  let compact = __compact !== undefined ? __compact : false;
  let size = Stdlib_Option.getOr(props.size, compact ? "small" : "normal");
  if (props.loyaltyProgramMember) {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Loy'"),
      size: size,
      borderColor: "#F6ABE6",
      backgroundColor: "#FDF2FB",
      foregroundColor: "#A01E72"
    });
  } else if (props.business) {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Pro"),
      size: size,
      borderColor: "#A9C5E7",
      backgroundColor: "#F2F6FC",
      foregroundColor: "#4F70C1"
    });
  } else {
    return null;
  }
});

let Badge$2 = {
  make: make$1
};

let make$2 = React.memo(props => {
  let __loyaltyProgramMember = props.loyaltyProgramMember;
  let business = props.business;
  let loyaltyProgramMember = __loyaltyProgramMember !== undefined ? __loyaltyProgramMember : false;
  let borderColor = business ? "#A9C5E7" : "#F6ABE6";
  let foregroundColor = business ? "#4F70C1" : "#A01E72";
  let backgroundColor = business ? "#F2F6FC" : "#FDF2FB";
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Avatar.make, {
        content: {
          NAME: "icon",
          VAL: business ? "store" : "contact_v3"
        },
        variant: "outline",
        tone: {
          NAME: "custom",
          VAL: {
            borderColor: borderColor,
            backgroundColor: backgroundColor,
            foregroundColor: foregroundColor
          }
        },
        size: "large"
      }),
      loyaltyProgramMember ? JsxRuntime.jsx(Offset.make, {
          children: JsxRuntime.jsx(make$1, {
            business: business,
            loyaltyProgramMember: loyaltyProgramMember,
            size: "xxsmall"
          }),
          bottom: -2.4,
          left: 4.4,
          width: 26
        }) : null
    ]
  });
});

let Avatar$1 = {
  make: make$2
};

export {
  makeName,
  Kind,
  Status,
  formatAge,
  isBirthdaySoon,
  Badge$2 as Badge,
  Avatar$1 as Avatar,
}
/* make Not a pure module */
